var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h6"},[_vm._v(" "+_vm._s(_vm.$t('Welcome back'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }